/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export const getActiveMegaVerbBeforeFullScreenMode = stores => stores.pageByPageStore.activeMegaVerbBeforeFullScreen;

export const getReasonOfExitFromFullScreenMode = stores => stores.pageByPageStore.reasonOfExitFromFullScreenMode;

export const getTotalPageVisitedInFullScreenMode = stores => stores.pageByPageStore.visitedPagesInFullScreen.size;

export const shouldEnableFitOneFullPageMode = stores => stores.pageByPageStore.enableFitOneFullPageMode;

export const getPagePositionFromTop = stores => stores.pageByPageStore.pagePositionFromTop;

export const getPageByPageScrollTop = stores => stores.pageByPageStore.pageByPageScrollTop;

export const getScrollTopAsPerScrubber = stores => stores.pageByPageStore.scrollTopAsPerScrubber;
